import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import Goods from './goods-manage/router'
import Mall from './mall-manage/router'
import Staff from './staff-manage/staff'
import Order from './order-manage/order'
import Data from './data-manage/data'
import Material from './material-manage/material'
import Setting from './setting-manage/router'
import Marketing from './marketing-manage/router'
import AiAssistant from './ai-assistant/ai-assistant'
import Member from './member-manage/member'
import { AI_ASSISTANT_PATH } from './ai-assistant/constants'
import { observer } from 'mobx-react'
import { staffStore } from '@/store/staff'

const ModuleRoutes = observer((props: RouteComponentProps) => {
    const restrictedRoute = (path: string, component: React.ComponentType<any>, permission: number) => (
        <Route
            path={props.match.path + path}
            render={routeProps =>
                staffStore.canIUse(permission) ? (
                    React.createElement(component, routeProps)
                ) : (
                    <div role="alert" style={{ padding: 32 }}>
                        暂无此模块权限，请联系店铺管理员。
                    </div>
                )
            }
        />
    )

    return (
        <Switch>
            <Route path={props.match.path + '/ai-assistant'} component={AiAssistant}></Route>
            <Route path={props.match.path + '/goods'} component={Goods}></Route>
            <Route path={props.match.path + '/mall'} component={Mall}></Route>
            <Route path={props.match.path + '/staff'} component={Staff}></Route>
            <Route path={props.match.path + '/order'} component={Order}></Route>
            {restrictedRoute('/data', Data, 3)}
            <Route path={props.match.path + '/material'} component={Material}></Route>
            <Route path={props.match.path + '/marketing'} component={Marketing}></Route>
            {restrictedRoute('/setting', Setting, 5)}
            {restrictedRoute('/member', Member, 4)}
            <Redirect exact from={props.match.path} to={AI_ASSISTANT_PATH}></Redirect>
        </Switch>
    )
})

export default ModuleRoutes
